import { API_URLS } from '@services/apiRoutes'

import type { BudgetValidationStatusProps } from './types'

import * as apiFunction from '@services/apiFunctions'

export const getBudgetValidationStatus = async (): Promise<BudgetValidationStatusProps> => {
  return await apiFunction.apiRequestWithQueryParams({
    url: API_URLS.auth.budgetFy27ValidationStatus,
    method: 'GET'
  })
}

export const ackBudgetValidationPopup = async (): Promise<BudgetValidationStatusProps> => {
  return await apiFunction.apiRequestWithBody({
    url: API_URLS.auth.budgetFy27ValidationStatus,
    method: 'PATCH',
    body: { visualizado: true }
  })
}
